import { createSlice } from "@reduxjs/toolkit";
import dynamicSocketUrl from "../../config/socketUrl";

const initialState = {
  liveData: {
    aid: null,
    feedback: null,
    salary_details: null,   // ✅ matches DB column & adminInfo key
    feedback_date: null,
  },
  isConnected: false,
  error: null,
  unseenUpdates: {
    feedback: false,
    salary_details: false,  // ✅ consistent key
  },
};

const sseSlice = createSlice({
  name: "sse",
  initialState,
  reducers: {
    setLiveData: (state, action) => {
      state.liveData = { ...state.liveData, ...action.payload };
    },
    connectionEstablished: (state) => {
      state.isConnected = true;
      state.error = null;
    },
    connectionError: (state, action) => {
      state.isConnected = false;
      state.error = action.payload;
    },
    resetLiveData: (state) => {
      state.liveData = initialState.liveData;
    },
    markUpdatesAsSeen: (state) => {
      state.unseenUpdates = initialState.unseenUpdates;
    },
    setUnseenFeedback: (state, action) => {
      state.unseenUpdates.feedback = action.payload;
    },
    setUnseenSalaryDetails: (state, action) => {       // ✅ renamed
      state.unseenUpdates.salary_details = action.payload;
    },
  },
});

export const {
  setLiveData,
  connectionEstablished,
  connectionError,
  resetLiveData,
  markUpdatesAsSeen,
  setUnseenFeedback,
  setUnseenSalaryDetails,
} = sseSlice.actions;

export const selectUnseenCount = (state) =>
  Object.values(state.sse.unseenUpdates).filter(Boolean).length;

// ── SSE Thunk ──────────────────────────────────────────────
export const initializeSSE = () => (dispatch, getState) => {
  const eventSource = new EventSource(`${dynamicSocketUrl()}/bbgapi/sse`, {
    withCredentials: true,
  });

  eventSource.addEventListener("open", () => {
    dispatch(connectionEstablished());
  });

  eventSource.addEventListener("message", (event) => {
  try {
    const message = JSON.parse(event.data);

    if (message.type === "salary_added") {
      const { aid, updatedFields, timestamp } = message.data;

      // ✅ Get current logged-in user's aid
      const adminDataString = localStorage.getItem("adminData");
      const adminData = adminDataString ? JSON.parse(adminDataString) : null;
      const adminInfo = adminData?.data || adminData;
      const currentAid = adminInfo?.aid;

      // ✅ Ignore updates meant for other users
      if (!currentAid || String(aid) !== String(currentAid)) return;

      const currentLive = getState().sse.liveData;

      const incomingSalaryDetails =
        updatedFields.salary_details ?? null;

      const incomingFeedback =
        updatedFields.feedback != null
          ? updatedFields.feedback.trim()
          : null;

      if (
        incomingSalaryDetails !== null &&
        JSON.stringify(incomingSalaryDetails) !==
          JSON.stringify(currentLive.salary_details)
      ) {
        dispatch(setUnseenSalaryDetails(true));
      }

      if (incomingFeedback !== null && incomingFeedback !== currentLive.feedback) {
        dispatch(setUnseenFeedback(true));
      }

      dispatch(
        setLiveData({
          aid,    
          feedback: incomingFeedback,
          salary_details: incomingSalaryDetails,
          feedback_date: incomingFeedback !== null ? timestamp : null,
        })
      );
    }
  } catch (error) {
    // console.error("Error parsing SSE message:", error);
  }
});

  eventSource.onerror = (error) => {
    // console.error("SSE error:", error);
    dispatch(connectionError(error.message));
    eventSource.close();
  };

  return () => {
    eventSource.close();
    dispatch(resetLiveData());
  };
};

export default sseSlice.reducer;